import Select       from 'components/App/IntlSelect';
import { observer } from 'mobx-react';
import { appStore } from 'stores/AppStore';
import { EN, FR }   from 'constants/Languages';

import flagFr from '/images/flag-fr.png?url';
import flagEn from '/images/flag-en.png?url';

interface SwitchLanguageProps {
  iconMode?: boolean;
  onSwitchTo?: (value: any) => Promise<void>;
}

const SwitchLanguage = observer(({
  iconMode,
  onSwitchTo,
}: SwitchLanguageProps) => (
  <Select
    allowClear={false}
    onChange={async (value: string) => {
      switch (value) {
        case EN.value:
          if (onSwitchTo) {
            await onSwitchTo(value);
          }
          appStore.switchToEnglish();
          break;
        case FR.value:
          if (onSwitchTo) {
            await onSwitchTo(value);
          }
          appStore.switchToFrench();
          break;
        default:
          if (onSwitchTo) {
            await onSwitchTo(value);
          }
          appStore.switchToNull();
      }
    }}
    placeholder="Sélectionner une langue"
    style={iconMode ? {} : { width: 128 }}
    value={appStore.locale}
  >
    <Select.Option value={EN.value}>
      <div>
        <img alt="flagEn" src={flagEn} style={{ marginRight: 8, width: '15px' }} />
        {!iconMode && EN.label}
      </div>
    </Select.Option>
    <Select.Option value={FR.value}>
      <div>
        <img alt="logo" src={flagFr} style={{ marginRight: 8, width: '15px' }} />
        {!iconMode && FR.label}
      </div>
    </Select.Option>
  </Select>
));

export default SwitchLanguage;
